<template lang="pug">
extends ../../../components/filter/dynamic-filter-template.pug

block item
    template(#receipts.drawer_session_id="props")
        div
            span.block {{ props.value.display_name }}
            small.text-muted(v-if="props.value.owner_outlets")
                | {{ props.value.outlet_name }} <br/>
            small.text-muted
                | {{ props.value.staff_name }}

    template(#receipts.day_operation_id="props")
        div
            span.block {{ props.value.display_name }}
            small.text-muted(v-if="props.value.owner_outlets")
                | {{ props.value.outlet_name }} </br>
            small.text-muted
                | {{ props.value.staff_name }}

</template>

<script>
import { mapActions, mapMutations, mapState, mapGetters } from 'vuex';
import dynamicFilterBase from '@js/components/filter/dynamic-filter-base';
import StoreMixin from './store-mixin';
import Report from '@js/plugins/report';

export default {
    extends: dynamicFilterBase,

    mixins: [StoreMixin],

    data() {
        let that = this;

        return {
            preSelectOperator: true,
            returnOperatorValueList: true,

            externalRemotes: {
                closure(query) {
                    return that
                        .getTillClosureListIfNecessary({
                            ...that.tillFilter,
                            query,
                        })
                        .then(data => {
                            return data.map(d => {
                                let id = d.id;

                                if (Report.pgsqlStrategy('transaction')) {
                                    id = d.drawer_session_number;
                                }

                                return {
                                    id: id,
                                    display_name: d.sequence_number,
                                    outlet_name: d.outlet_name,
                                    staff_name: d.staff_name,
                                };
                            });
                        });
                },

                attendant(query) {
                    return that
                        .getTillAttendantListIfNecessary({
                            ...that.tillFilter,
                            query,
                        })
                        .then(data => {
                            return data.map(d => {
                                let id = d.id;

                                if (Report.pgsqlStrategy('transaction')) {
                                    id = d.attendant_session_number;
                                }

                                return {
                                    id: id,
                                    display_name: d.sequence_number,
                                    outlet_name: d.outlet_name,
                                    staff_name: d.staff_name,
                                };
                            });
                        });
                },

                summary(query) {
                    return that
                        .getTillSummaryListIfNecessary({
                            ...that.tillFilter,
                            query,
                        })
                        .then(data => {
                            return data.map(d => ({
                                id: d.id,
                                display_name: d.sequence_number,
                                outlet_name: d.outlet_name,
                                staff_name: d.staff_name,
                            }));
                        });
                },

                cashier(query) {
                    return that
                        .getStaffListIfNecessary({
                            ...that.staffFilter,
                            query,
                        })
                        .then(data => {
                            return data.map(d => ({
                                id: d.staff_id,
                                display_name: d.staff_name,
                            }));
                        });
                },

                attendantStaff(query) {
                    return that
                        .getAttendantStaffIfNecessary({
                            ...that.staffFilter,
                            query,
                        })
                        .then(data => {
                            return data.map(d => ({
                                id: d.staff_id,
                                display_name: d.staff_name,
                            }));
                        });
                },
            },
        };
    },

    computed: {
        ...mapGetters(['activeOutlet', 'startDate', 'endDate']),
        ...mapState('transaction', ['searchMeta']),
        ...mapState('tillFilter', ['filters']),

        loading() {
            return this.onLoading('get-transaction-meta');
        },

        tillFilter() {
            return {
                outlet_id: this.activeOutlet,
                since: this.startDate.format(),
                until: this.endDate.format(),
            };
        },

        staffFilter() {
            return {
                outlet_id: this.activeOutlet,
            };
        },
    },

    created() {
        if (Report.pgsqlStrategy('transaction')) {
            this.getSearchMetaIfNecessaryV2();
        } else {
            this.getSearchMetaIfNecessary();
        }
    },

    methods: {
        ...mapActions('tillFilter', [
            'getTillSummaryListIfNecessary',
            'getTillClosureListIfNecessary',
            'getTillAttendantListIfNecessary',
        ]),

        ...mapActions('transaction', [
            'getSearchMetaIfNecessary',
            'getSearchMetaIfNecessaryV2',
        ]),

        ...mapActions('priceOverride', ['getStaffListIfNecessary']),

        ...mapMutations('tillFilter', ['setFilters']),

        ...mapActions('attendantSession', ['getAttendantStaffIfNecessary']),
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/transaction/filters/transaction-dynamic-filter.vue